<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateAssignTeamLeadPreference(value: boolean) {
  await settingsStore.set('projectsAssignTeamLead', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.projectsAssignTeamLead"
    :label="t('settings.projects.assignAsTeamLead')"
    :description="t('settings.projects.assignAsTeamLeadDescription')"
    @change="updateAssignTeamLeadPreference"
  />
</template>